module.exports = __webpack_public_path__ + "media/images/bg-91a7d68eb40e373b3d47e68d7fcbd2e0.png";